import React from "react";
import { ArrowDownIcon, ArrowRightIcon, CheckIcon, XIcon } from "lucide-react";
import { Section, SectionHeading } from "../Section";
import { CTAButton } from "../CTAButton";
import { afterItems, beforeItems } from "../../data/landing";
export function BeforeAfter() {
  return <Section className="bg-white" data-id="element-83" data-mp="22l12pb3fr9fc">
      <SectionHeading title="What could change when your articulation workflow is better organized?" data-id="element-84" data-mp="22m2fpl40i5zp" />

      <div className="mt-10 grid items-stretch gap-4 md:grid-cols-[1fr_auto_1fr] md:gap-5" data-id="element-85" data-mp="2z9qnpaad0i5j">
        <div className="rounded-3xl bg-blush-soft p-6 ring-2 ring-blush/20 sm:p-8" data-id="element-86" data-mp="2ud044czcj4fd">
          <p className="inline-flex rounded-full bg-blush px-4 py-1.5 font-display text-sm font-bold uppercase tracking-wide text-white" data-id="element-87" data-mp="2q9kazqmhjm7f">
            Before
          </p>
          <h3 className="mt-3 font-display text-2xl font-bold text-navy" data-id="element-88" data-mp="1ev6sl1ai3yys">Disconnected planning</h3>
          <ul className="mt-5 space-y-4" data-id="element-89" data-mp="19w3mremp5opr">
            {beforeItems.map(item => <li key={item} className="flex items-start gap-3 text-[16px] font-semibold leading-snug text-ink/85" data-id="element-90" data-mp="19ygbqbqvgzcb">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-blush/15 text-blush" data-id="element-91" data-mp="1c47554ywi236">
                  <XIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-92" data-mp="y3mlk6l5w28m" />
                </span>
                {item}
              </li>)}
          </ul>
        </div>

        <div className="flex items-center justify-center" aria-hidden="true" data-id="element-93" data-mp="oemk8gj6sur9">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-navy text-white" data-id="element-94" data-mp="t5baxtn1lnpc">
            <ArrowDownIcon className="h-6 w-6 md:hidden" data-id="element-95" data-mp="fegbf7yfoiyf" />
            <ArrowRightIcon className="hidden h-6 w-6 md:block" data-id="element-96" data-mp="fg14su90hvup" />
          </span>
        </div>

        <div className="rounded-3xl bg-mint-soft p-6 ring-2 ring-mint/25 sm:p-8" data-id="element-97" data-mp="jg1k0h3xqb2t">
          <p className="inline-flex rounded-full bg-mint px-4 py-1.5 font-display text-sm font-bold uppercase tracking-wide text-white" data-id="element-98" data-mp="5hbkkutn7zba">
            After
          </p>
          <h3 className="mt-3 font-display text-2xl font-bold text-navy" data-id="element-99" data-mp="2c4st461kptyi">A more structured approach</h3>
          <ul className="mt-5 space-y-4" data-id="element-100" data-mp="27dap19497d9b">
            {afterItems.map(item => <li key={item} className="flex items-start gap-3 text-[16px] font-bold leading-snug text-ink" data-id="element-101" data-mp="23bpehuf6zb2a">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-mint text-white" data-id="element-102" data-mp="1yde51kst72kl">
                  <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-103" data-mp="2v1u01weou453" />
                </span>
                {item}
              </li>)}
          </ul>
        </div>
      </div>

      <div className="mx-auto mt-10 max-w-2xl text-center text-lg leading-relaxed text-ink/85" data-id="element-104" data-mp="2m15mf2t7i5sq">
        <p data-id="element-105" data-mp="2h2kioteqx3zj">The purpose isn't to replace your clinical judgment with a rigid formula.</p>
        <p className="mt-2 font-bold text-navy" data-id="element-106" data-mp="1aobefng75zdy">
          It's to give you practical educational resources that help you organize your work while keeping each child's
          individual needs at the center.
        </p>
      </div>

      <div className="mt-10" data-id="element-107" data-mp="vi5obgnbk8n4">
        <CTAButton label="I want the structured approach" data-id="element-108" data-mp="10j3gmm21mj2c" />
      </div>
    </Section>;
}